<template>
  <div class="award_section">
    <div class="awards_photo_album">
      <v-alert v-if="pending_payment"
               :value="true"
               type="warning"
               class="notranslate"
       >
        {{ $t('pending_payment') }}
        <a v-if="get_last_payment && get_last_payment.details['payment_method'] === 'boleto' && validateTime(get_last_payment.details['boleto_expiration_date'])"
           :href="get_last_payment.details['boleto_url']"
           target="_blank"
        >{{ $t('view_bank_slip') }}</a>
        <a v-else-if="get_last_payment && get_last_payment.details['payment_method'] === 'boleto' && !validateTime(get_last_payment.details['boleto_expiration_date'])"
           href="#"
           @click.prevent="payAwards(total_to_pay)"
        >{{ $t('expired_boleto') }}</a>
        <a v-else
           href="#"
           @click.prevent="payAwards(total_to_pay)"
        >{{ $t('try_payment_again') }}</a>
      </v-alert>
      <template v-else-if="allAlbunsCompleted && !pending_payment">
        <v-alert
          v-if="total_entries < free_entries"
          :value="true"
          type="success"
          class="notranslate"
        >
          {{ !already_submitted ? $t('you_can_send_up_to') : $t('confirmed_can_send_more') }}
          {{ $t('free_and_extra_entries_available', [
            free_entries - total_entries,
            parseInt(award['max_entries'], 10) - free_entries,
            extra_entry_price_formatted
          ]) }}
        </v-alert>
        <v-alert
          v-else-if="total_entries >= free_entries && total_entries < parseInt(award['max_entries'], 10)"
          :value="true"
          type="info"
          class="notranslate"
        >
          <template v-if="!already_submitted">
            {{ $t('extra_entries_available_and_price', [
              parseInt(award['max_entries'], 10) - total_entries,
            extra_entry_price_formatted
            ]) }}
          </template>
          <template v-else>
            {{ $t('confirmed_can_send_more_extra', [
              parseInt(award['max_entries'], 10) - total_entries,
            extra_entry_price_formatted
            ]) }}
          </template>
        </v-alert>
        <v-alert
          v-else-if="(total_entries === parseInt(award['max_entries'], 10)) && !already_submitted"
          :value="true"
          type="warning"
          class="notranslate"
        >
          {{ $t('maximum_reached') }}
        </v-alert>
        <v-alert
          v-else-if="(total_entries === parseInt(award['max_entries'], 10)) && (already_submitted['submission'].length < parseInt(award['max_entries'], 10))"
          :value="true"
          type="warning"
          class="notranslate"
        >
          {{ $t('maximum_reached') }}
        </v-alert>
        <v-alert
          v-else-if="(total_entries === parseInt(award['max_entries'], 10)) && (already_submitted['submission'].length >= parseInt(award['max_entries'], 10))"
          :value="true"
          type="success"
          class="notranslate"
        >
          {{ $t('maximum_reached_submitted') }}
        </v-alert>
      </template>
      <v-alert
        v-else
        :value="true"
        type="warning"
        class="notranslate"
      >
        {{ $t('albuns_should_contain') }}
      </v-alert>
      <div class="awards_photo_albuns">
        <AwardsSinglePhotoAlbum v-for="(album, index) in albums"
          :key="index"
          :position="index"
          :album="album"
          :award="award"
          :pending_payment_message="pending_payment_message"
          :has_categories="hasCategories"
          @update-album="updateAlbum"
          @remove-image="removeImageFromAlbum"
          @update-title="updateTitle"
          @update-location="updateLocation"
          @update-category="updateCategory"
          @remove-album="removeAlbum"
          @pay-awards="payAwards(total_to_pay)"
        />
      </div>
      <v-btn class="add_more"
             color="accent"
             v-if="canAddMore"
             @click="addAlbum"
             large
      >
        {{(free_entries - total_entries >= 1) ? str.add_free_album : str.add_extra_album}}
        <v-icon class="notranslate" right dark>add_circle</v-icon>
      </v-btn>

      <AwardsBottomPay
        v-show="entries_to_submit >= 1 && allAlbunsCompleted"
        :total_to_pay="total_to_pay"
        @submit="confirm_dialog = true"
      />

    </div>
    <AwardsSideInfo :award="award"
                    :readyToSubmit="allAlbunsCompleted"
                    :total_to_pay="total_to_pay"
                    :entries_to_submit="entries_to_submit"
                    :free_entries_available="free_entries_available"
                    :extra_entries="extra_entries"
                    :submission="albums"
                    :profile="profile"
                    @submit="confirm_dialog = true"
    />
    <v-dialog v-model="confirm_dialog" persistent max-width="492">
      <v-card>
        <v-card-title class="headline">{{ $t('confirm_submission') }}?</v-card-title>
        <v-card-text>{{ $t('rules_agreement') }}</v-card-text>
        <v-card-text>
          {{ $t('admit_judges_comments') }}
          <v-radio-group v-model="admit_comments" column>
            <v-radio :label="$t('admit_judges_comments_allow')" value="allow"></v-radio>
            <v-radio :label="$t('admit_judges_comments_refuse')" value="refuse"></v-radio>
          </v-radio-group>
          <v-card-text class="admit_comments_allow_alert"
                       v-if="admit_comments === 'allow'"
          >{{ $t('admit_judges_comments_accept_note') }}</v-card-text>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed
                 color="accent"
                 @click="submitAwards"
                 :disabled="!admit_comments"
          >{{ total_to_pay > 0 ? $t('submit_and_pay') : $t('submit') }}</v-btn>
          <v-btn flat
                 color="info"
                 :href="award[`rules_page_${lang}_url`]"
                 target="_blank"
          >{{ str.read_the_rules }}</v-btn>
          <v-btn flat @click="confirm_dialog = false">{{ $t('close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="success_dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{ str.success_dialog_title }}</v-card-title>
        <v-card-text>{{ str.success_dialog_text }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="success_dialog = false">{{str.close}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="error_dialog" persistent max-width="420">
      <v-card>
        <v-card-title class="headline">{{ str.error_dialog_title }}</v-card-title>
        <v-card-text>{{ str.error_dialog_text }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="accent" @click="submitAwards">{{str.try_again}}</v-btn>
          <v-btn flat @click="error_dialog = false">{{str.close}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="payment.dialog" max-width="470">
      <v-card>
        <v-card-title class="headline">
          <v-icon color="success"
                  class="notranslate"
                  left
                  v-if="payment.status === 'paid'"
          >check_circle</v-icon>
          <v-icon color="info"
                  class="notranslate"
                  left
                  v-else-if="payment.status === 'waiting_payment'"
          >info</v-icon>
          <v-icon color="error"
                  class="notranslate"
                  left
                  v-else
          >warning</v-icon>
          {{payment.title}}
        </v-card-title>
        <v-card-text>{{payment.text}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat
                 v-if="payment.status === 'waiting_payment'"
                 color="accent"
                 :href="payment.url"
                 target="_blank"
          >{{str.view_bank_slip}}</v-btn>
          <v-btn flat
                 v-else-if="payment.status === 'refused'"
                 color="accent"
                 @click="submitAwards"
          >{{str.try_again}}</v-btn>
          <v-btn flat @click="payment.dialog = false">
            {{str.close}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="submitting" v-show="submitting.active">
      <h2>{{str.submiting}}</h2>
      <p v-if="submitting.current>0">
        {{str.processing_image}}
        {{submitting.current}}
        {{str.processing_image_of}}
        {{submitting.max}}
      </p>
      <p v-else>{{str.processing_submission}}</p>
      <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>

  </div>
</template>

<script>
import VDialog from 'vuetify/es5/components/VDialog/VDialog'
import VCard from 'vuetify/es5/components/VCard/VCard'
import VRadio from 'vuetify/es5/components/VRadioGroup/VRadio'
import VRadioGroup from 'vuetify/es5/components/VRadioGroup/VRadioGroup'
import AwardsSideInfo from './AwardsSideInfo'
import AwardsSinglePhotoAlbum from './AwardsSinglePhotoAlbum'
import { submitAwards, registerAwards } from '../utils/api'
import paymentMixin from '../utils/payment_mixin'
import { UPDATE_USER, UPDATE_SEGMENTS } from '../store/types'
import * as moment from 'moment'
import strings from '../strings/AwardsPhotoAlbum'
import AwardsBottomPay from './AwardsBottomPay'
export default {
  name: 'AwardsPhotoAlbum',
  components: { AwardsBottomPay, AwardsSinglePhotoAlbum, AwardsSideInfo, VDialog, VCard, VRadio, VRadioGroup },
  mixins: [
    paymentMixin
  ],
  props: {
    award: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      error: false,
      albums: [],
      confirm_dialog: false,
      success_dialog: false,
      error_dialog: false,
      admit_comments: '',
      submitting: {
        active: false,
        current: 0,
        max: 0
      },
      payment: {
        dialog: false,
        title: '',
        text: '',
        status: ''
      }
    }
  },
  computed: {
    lang: function () {
      return this.$store.state.user.language ? this.$store.state.user.language : 'en'
    },
    str: function () {
      return Object.keys(strings).reduce((acc, key) => {
        return {
          ...acc,
          [key]: strings[key][this.lang]
        }
      }, {})
    },
    hasCategories: function () {
      return (this.award['participant_segment'] === 'photographer')
    },
    allAlbunsCompleted: function () {
      if (this.hasCategories) {
        return this.albums.filter(album =>
          album.images.length === 20 && album.title !== '' && album.location !== '' && album.category !== ''
        ).length === this.albums.length
      } else {
        return this.albums.filter(album =>
          album.images.length === 20 && album.title !== '' && album.location !== ''
        ).length === this.albums.length
      }
    },
    canAddMore: function () {
      if (this.already_submitted) {
        if (
          this.already_submitted['payment_status'] === 'paid' ||
          this.already_submitted['payment_status'] === 'completed' ||
          this.already_submitted['payment_status'] === 'waiting_payment' ||
          this.already_submitted['payment_status'] === 'processing' ||
          this.already_submitted['payment_status'] === 'free'
        ) {
          return (
            (this.albums.length < this.award['max_entries']) &&
            this.allAlbunsCompleted
          )
        } else {
          return false
        }
      } else {
        return (
          (this.albums.length < this.award['max_entries']) &&
          this.allAlbunsCompleted
        )
      }
    },
    profile: function () {
      return this.$store.state.segments
        .find(el => el.slug === this.award['participant_segment'])
    },
    total_entries: function () {
      if (this.hasCategories) {
        return this.albums.filter(album =>
          album.images.length === 20 && album.title !== '' && album.location !== '' && album.category !== ''
        ).length
      } else {
        return this.albums.filter(album =>
          album.images.length === 20 && album.title !== '' && album.location !== ''
        ).length
      }
    },
    already_submitted: function () {
      const awardsSubmissions = this.$store.state.segments
        .find(el => el.slug === this.award['participant_segment'])['data']['awards_submissions']
      const thisAwardsIndex = Object.keys(awardsSubmissions).find(el => el == this.award['id'])
      if (thisAwardsIndex) {
        return awardsSubmissions[thisAwardsIndex]
      } else {
        return false
      }
    },
    already_confirmed: function () {
      if (this.already_submitted) {
        if (this.already_submitted['submission'].length <= this.free_entries) {
          return this.already_submitted['submission'].length
        } else {
          const alreadyPaidFor = Math.round(this.already_submitted['amount_paid'] / this.extra_entry_price)
          return alreadyPaidFor + this.free_entries
        }
      } else {
        return 0
      }
    },
    entries_to_submit: function () {
      if (this.already_submitted) {
        return Math.max(0, (this.total_entries - this.already_submitted['submission'].length))
      } else {
        return this.total_entries
      }
    },
    free_entries: function () {
      return this.profile.data.is_pro
          ? parseInt(this.award['free_entries'], 10)
          : 0
    },
    free_entries_available: function () {
      const defaultFreeEntries = this.free_entries
      if (this.already_submitted) {
        return Math.max(0, (defaultFreeEntries - this.already_submitted['submission'].length))
      } else {
        return defaultFreeEntries
      }
    },
    extra_entries: function () {
      return Math.max(0, (this.entries_to_submit - this.free_entries_available))
    },
    extra_entry_price: function () {
      const entry_field = this.$store.state.user['address']['country'].toLowerCase() === 'br'
        ? 'entry_price_brl'
        : 'entry_price_usd'
      const value = parseInt(this.award[entry_field], 10)
      return this.profile.data.is_pro ? value : value * 2
    },
    extra_entry_price_formatted: function () {
      const amount = (this.extra_entry_price / 100).toFixed(2)
      return (this.$store.state.user['address']['country'].toLowerCase() === 'br')
          ? amount.replace('.', ',')
          : amount
    },
    total_to_pay: function () {
      if (this.already_submitted) {
        let entriesPending
        if (
          this.already_submitted['payment_status'] === 'waiting_payment' ||
          this.already_submitted['payment_status'] === 'processing'
        ) {
          entriesPending = (this.total_entries - this.already_submitted['submission'].length)
        } else {
          entriesPending = (this.total_entries - this.already_confirmed)
        }
        return entriesPending * this.extra_entry_price
      } else {
        return this.extra_entries * this.extra_entry_price
      }
    },
    pending_payment: function () {
      if (this.already_submitted) {
        return !(
          this.already_submitted['payment_status'] === 'paid' ||
          this.already_submitted['payment_status'] === 'completed' ||
          this.already_submitted['payment_status'] === 'free'
        )
      } else {
        return false
      }
    },
    pending_payment_message: function () {
      if (this.pending_payment) {
        if (
          this.get_last_payment &&
          this.get_last_payment.details['payment_method'] === 'boleto' &&
          this.validateTime(this.get_last_payment.details['boleto_expiration_date'])
        ) {
          return {
            message: this.str.view_bank_slip,
            url: this.get_last_payment.details['boleto_url']
          }
        } else if (
          this.get_last_payment &&
          this.get_last_payment && this.get_last_payment.details['payment_method'] === 'boleto' &&
          !this.validateTime(this.get_last_payment.details['boleto_expiration_date'])
        ) {
          return {
            message: this.str.expired_boleto,
            url: null
          }
        } else {
          return {
            message: this.str.try_again,
            url: null
          }
        }
      } else {
        return null
      }
    },
    get_last_payment: function () {
      if (this.already_submitted) {
        return this.$store.state.user['payment_history']
          .find(el => el.id === this.already_submitted['payment_id'])
      } else {
        return null
      }
    }
  },
  methods: {
    validateTime: function (time) {
      return moment().isBefore(time * 1000)
    },
    updateAlbum: function (index, images) {
      this.albums = [
        ...this.albums.slice(0, index),
        {
          ...this.albums[index],
          images: [
            ...this.albums[index].images,
            ...images
          ]
        },
        ...this.albums.slice(index + 1)
      ]
    },
    removeImageFromAlbum: function (albumIndex, imageIndex) {
      this.albums = [
        ...this.albums.slice(0, albumIndex),
        {
          ...this.albums[albumIndex],
          images: this.albums[albumIndex].images.filter((el, i) => i !== imageIndex)
        },
        ...this.albums.slice(albumIndex + 1)
      ]
    },
    addAlbum: function () {
      this.albums = [
        ...this.albums,
        {
          title: '',
          location: '',
          category: '',
          images: []
        }
      ]
    },
    removeAlbum: function (index) {
      this.albums = this.albums.filter((el, i) => i !== index)
    },
    updateTitle: function (albumIndex, newTitle) {
      this.albums = [
        ...this.albums.slice(0, albumIndex),
        {
          ...this.albums[albumIndex],
          title: newTitle
        },
        ...this.albums.slice(albumIndex + 1)
      ]
    },
    updateLocation: function (albumIndex, newLocation) {
      this.albums = [
        ...this.albums.slice(0, albumIndex),
        {
          ...this.albums[albumIndex],
          location: newLocation
        },
        ...this.albums.slice(albumIndex + 1)
      ]
    },
    updateCategory: function (albumIndex, newCategory) {
      this.albums = [
        ...this.albums.slice(0, albumIndex),
        {
          ...this.albums[albumIndex],
          category: newCategory
        },
        ...this.albums.slice(albumIndex + 1)
      ]
    },
    submitAwards: async function () {
      this.payment.dialog = false
      this.confirm_dialog = false
      this.error_dialog = false
      this.submitting.active = true
      this.submitting.current = 0
      this.submitting.max = 0
      const totalToPay = this.total_to_pay
      console.log('total to pay', totalToPay)

      const albumsToSubmit = this.albums.slice(this.already_submitted
        ? this.already_submitted['submission'].length
        : 0
      )

      const submissionChunks = albumsToSubmit.reduce((acc, cur) => {
        let addThis = []
        for (let i = 1; i <= 10; i++) {
          addThis.push({
            'title': cur['title'],
            'location': cur['location'],
            'category': cur['category'],
            'images': cur['images'].slice(((i - 1) * 2), (i * 2))
          })
        }
        return [
          ...acc,
          ...addThis
        ]
      }, [])
      let submitResult = []
      let errorCatched = false

      this.submitting.max = albumsToSubmit.length * 20

      let submissionChunksIndex = 1
      for (const el of submissionChunks) {
        if (errorCatched) break
        this.submitting.current = submissionChunksIndex
        await submitAwards(this.profile['data']['id'], this.award['id'], [el])
          .then(result => {
            if (!(result instanceof TypeError)) {
              console.log(result)
              submitResult.push(result)
              submissionChunksIndex = submissionChunksIndex + 2
            } else {
              errorCatched = true
            }
          })
          .catch(err => {
            console.log(err)
            errorCatched = true
          })
      }
      if (errorCatched) {
        this.submitting.active = false
        this.error_dialog = true
        return
      }

      console.log(submitResult)

      if (submitResult.find(el => el instanceof TypeError)) {
        this.submitting.active = false
        this.error_dialog = true
      } else {
        const finalSubsmission = submitResult.reduce((acc, cur) => {
          let albumIndex = -1
          acc.forEach((el, thisIndex) => {
            if (albumIndex === -1) {
              if (
                el['title'] === cur['awards_submission'][0]['title'] &&
                el['location'] === cur['awards_submission'][0]['location'] &&
                el['category'] === cur['awards_submission'][0]['category']
              ) {
                albumIndex = thisIndex
              }
            }
          })

          if (albumIndex === -1) {
            return [
              ...acc,
              cur['awards_submission'][0]
            ]
          } else {
            return [
              ...acc.slice(0, albumIndex),
              {
                title: cur['awards_submission'][0]['title'],
                location: cur['awards_submission'][0]['location'],
                category: cur['awards_submission'][0]['category'],
                images: [
                  ...acc[albumIndex].images,
                  ...cur['awards_submission'][0]['images']
                ]
              },
              ...acc.slice(albumIndex + 1)
            ]
          }
        }, [])
        console.log(finalSubsmission)

        registerAwards(
          this.profile['data']['id'],
          this.award['id'],
          finalSubsmission,
          this.admit_comments
        ).then(finalResult => {
          if (finalResult['result'] === 'success') {
            this.$store.commit(UPDATE_USER, finalResult['new_user'])
            this.$store.commit(UPDATE_SEGMENTS, finalResult['new_segments'])
            this.submitting.active = false
            this.updateAlbumsSubmitted()
            if (totalToPay > 0) {
              this.payAwards(totalToPay)
            } else {
              this.success_dialog = true
            }
          }
        })
      }
    },
    payAwards: function (totalToPay = 0) {
      console.log('payAwards invoked')
      const realTotalToPay = (totalToPay === 0) ? this.total_to_pay : totalToPay
      this.makePayment(
        realTotalToPay,
        {
          finality: 'awards',
          extra_entries: this.extra_entries.toString(),
          awards_title: this.award['title'],
          awards_id: this.award['id'],
          post_id: this.profile['data']['id'],
          user_id: this.$store.state.user.id
        },
        'boleto, credit_card'
      ).then(paymentResult => {
        console.log(paymentResult)
        this.updateAlbumsSubmitted()
        this.payment.dialog = true
        this.payment.title = paymentResult.title
        this.payment.text = paymentResult.text
        this.payment.status = paymentResult.status
        this.payment.url = paymentResult.url
      })
    },
    updateAlbumsSubmitted: function () {
      if (this.already_submitted) {
        this.albums = [
          ...Object.values(this.already_submitted['submission']).map((el, i) => {
            return {
              ...el,
              images: Object.values(el.images),
              submitted: true,
              confirmed: ((i + 1) <= this.already_confirmed)
            }
          })
        ]
      }
    }
  },
  mounted () {
    this.updateAlbumsSubmitted()
  }
}
</script>

<style scoped lang="scss">
  @keyframes sk-bouncedelay {
    0%, 80%, 100% {
      transform: scale(0);
    } 40% {
        transform: scale(1.0);
      }
  }
  .add_more {
    display: block;
    margin: 48px auto;
  }
  .v-alert {
    position: sticky;
    top: 84px;
    z-index: 39;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
    font-size: 16px;
    a {
      color: #fff;
    }
  }
  .submitting {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0,0,0,0.75);
    z-index: 999999;
    padding: 96px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-content: center;
    pointer-events: none;
    h2 {
      color: #fff;
      font-size: 36px;
    }
    p {
      color: #fff;
      margin: 0;
      font-size: 24px;
    }
    .spinner {
      margin: 48px auto 0;
      width: 84px;
      text-align: center;
      div {
        width: 24px;
        height: 24px;
        margin: 0 2px;
        background-color: rgba(255,255,255,0.7);
        border-radius: 100%;
        display: inline-block;
        animation: sk-bouncedelay 1.4s infinite ease-in-out both;
        &.bounce1 {
          animation-delay: -0.32s;
        }
        &.bounce2 {
          animation-delay: -0.16s;
        }
      }
    }
  }
</style>

<i18n>
  {
    "en": {
      "pending_payment": "The payment for this contest has not yet been confirmed. If you have already done, it will soon be confirmed.",
      "view_bank_slip": "View bank slip",
      "expired_boleto": "The previously generated payment has expired, but you can make another payment here.",
      "try_payment_again": "In case you haven't, please make payment here.",
      "you_can_send_up_to": "You can send up to",
      "confirmed_can_send_more": "Your participation in this contest has already been confirmed, but you can still submit up to",
      "free_and_extra_entries_available": "{0} more entries for free and {1} more extra entries for U$ {2} each",
      "extra_entries_available_and_price": "You can send up to {0} more entries for U$ {1} each",
      "confirmed_can_send_more_extra": "Your participation in this contest has already been confirmed, but you can still submit up to {0} more entries for U$ {1} each",
      "maximum_reached": "You have reached the maximum number of entries allowed",
      "maximum_reached_submitted": "Your participation in this contest has already been performed and your submission contains the maximum number of entries allowed",
      "albuns_should_contain": "Albums must contain 20 photos and all fields filled.",
      "confirm_submission": "Confirm submission",
      "rules_agreement": "By submitting you state that you have read and understood the rules, accept and agree to them, and also state that your submission respects it.",
      "admit_judges_comments": "In contests, the judges have the possibility to comment on the entries to give praise, ideas, constructive criticism and other thoughts. It is up to each judge to choose which entries he wishes to comment on.",
      "admit_judges_comments_allow": "I allow judges to comment in my participation.",
      "admit_judges_comments_accept_note": "Note: It is up to each judge to choose which photos will or will not comment. By checking that you accept to receive comments does not necessarily mean that you will receive them.",
      "admit_judges_comments_refuse":  "I'd like to judges to NOT comment in my participation.",
      "submit": "Submit",
      "submit_and_pay": "Submit and pay",
      "read_the_rules": "Read all the rules"
    },
    "pt": {
      "pending_payment": "O pagamento para este concurso ainda não foi confirmado. Caso já o realizou, em breve será confirmado.",
      "view_bank_slip": "Visualizar boleto",
      "expired_boleto": "O boleto gerado anteriormente venceu, mas você pode realizar outro pagamento aqui.",
      "try_payment_again": "Se ainda não o fez, faça o pagamento aqui.",
      "you_can_send_up_to": "Você pode enviar até mais",
      "confirmed_can_send_more": "Sua participação neste concurso já está confirmada, mas você ainda pode enviar até mais",
      "free_and_extra_entries_available": "{0} entrada(s) gratuitamente e mais {1} entrada(s) extras por R$ {2} cada",
      "extra_entries_available_and_price": "Você pode enviar até mais {0} entradas extras por R$ {1} cada",
      "confirmed_can_send_more_extra": "Sua participação neste concurso está confirmada, mas você pode enviar até mais {0} entradas extras por R$ {1} cada",
      "maximum_reached": "Você chegou ao máximo de entradas permitidas",
      "maximum_reached_submitted": "Sua participação neste concurso já foi realizada e seu envio contém o máximo de entradas permitidas",
      "albuns_should_contain": "Álbuns devem conter 20 fotos e todos campos preenchidos.",
      "confirm_submission": "Confirmar envio",
      "rules_agreement": "Ao finalizar, você atesta que leu e compreendeu o regulamento, aceita as regras e concorda com elas, declara também que seu envio está de acordo.",
      "admit_judges_comments": "Nos concursos, os juízes têm a possibilidade de comentar nas entradas para dar elogios, ideias, críticas construtivas e demais pensamentos. Fica ao critério de cada juiz escolher quais participações deseja comentar.",
      "admit_judges_comments_allow": "Permito que juízes comentem em minha participação.",
      "admit_judges_comments_accept_note": "Observação: Cabe a cada juiz escolher quais fotos irá ou não comentar. Ao marcar que aceita receber comentários não significa que necessariamente os receberá.",
      "admit_judges_comments_refuse": "Não desejo que juízes comentem em minha participação.",
      "submit": "Enviar",
      "submit_and_pay": "Enviar e pagar",
      "read_the_rules": "Ler regulamento completo"
    }
  }
</i18n>
